import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
	LanguageService,
	StorageService,
	TempKey,
	TEMP_KEY_PREFIX,
	VolatileKey,
} from '@services/public';
import { Subscription } from 'rxjs';
import { DECISION_PAGE, DECISION_PREVIOUS_PAGE, DecisionData } from './common';
import { SKILL_BUILDER_TYPES, SkillBuilderService } from '@services/member';
import { APIErrors, isAPIErrors } from '@util';

const PAGE_PATH: string = 'skillBuilders.decision.pages.main';

@Component({
	selector: 'app-member-skill-builder-decision',
	templateUrl: './decision.component.html',
	styleUrls: ['./decision.component.scss'],
})
export class MemberSkillBuilderDecisionComponent implements OnInit, OnDestroy {
	DECISION_PAGE: typeof DECISION_PAGE = DECISION_PAGE;
	data: DecisionData;
	private _subscriptions: Subscription = new Subscription();

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
	};

	constructor(
		private _router: Router,
		private _skillBuilderSvc: SkillBuilderService,
		private _storageSvc: StorageService,
		private _languageSvc: LanguageService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});

		// Get decision data.
		this.data = this._storageSvc.getTempStorage(TempKey.DECISION);
		const goalPlanUUID = this._storageSvc.getVolatileStorage(
			VolatileKey.GOAL_PLAN_UUID,
			true,
		);
		if (!this.data) {
			this._skillBuilderSvc
				.getStatus(SKILL_BUILDER_TYPES.DECISION, goalPlanUUID)
				.subscribe((res: DecisionData | APIErrors) => {
					if (!isAPIErrors(res) && !this.data) {
						this.data = {
							...res,
							page: res.start
								? DECISION_PAGE.AFFECTS
								: DECISION_PAGE.TAKEN_ACTION,
						};

						this._setStorageSubscription();
					}
				});
		} else this._setStorageSubscription();
	}

	private _setStorageSubscription() {
		this._subscriptions.add(
			this._storageSvc.updates.subscribe((update) => {
				if (update.key === TEMP_KEY_PREFIX + TempKey.ALL)
					this.data = update.value[TempKey.DECISION];
				if (update.key === TEMP_KEY_PREFIX + TempKey.CLEAR) this.data = null;
				if (update.key === TEMP_KEY_PREFIX + TempKey.DECISION)
					this.data = update.value;
				if (!this.data && !this._router.getCurrentNavigation())
					this._router.navigate(['member/dashboard']);
			}),
		);
	}

	back() {
		const page = DECISION_PREVIOUS_PAGE[this.data.page];
		if (!page) {
			this._router.navigate(['member/dashboard']);
			return;
		}
		this._storageSvc.setTempStorage(TempKey.DECISION, { ...this.data, page });
	}

	ngOnDestroy(): void {
		this._subscriptions.unsubscribe();
		this._storageSvc.setTempStorage(TempKey.DECISION, null);
	}
}
